import {Page} from "./page";

/**
 * An array of data with an associated page object used for paging
 */
export class PagedData<T> {
    data = new Array<T>();
    page = new Page();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb_dashboard/datatable/paged-data.ts